export default {
    bgColor: 0xfc802d,
    primaryKey: "BGElmnts_NinjaStr",
    secondaryKey: "BGElmnt_Cns",
    animateIn: (data, bg)=>{
        let image = bg.create(bg.scene.mid.x, bg.scene.mid.y, data.key);
        
        image.setPosition(-500, data.y);
        image.setScale(data.scaleX);
        image.angle = -180;
        let deltaX = 1-(data.x/bg.scene.size.width);
        let deltaY = 1-(data.y/bg.scene.size.height);

        bg.scene.addTween(image, 600, {angle: data.angle, x: data.x, delay: (600 * deltaX) + (300 * deltaY)}, Phaser.Math.Easing.Sine.In);
    },
    animateOut: (image, bg)=>{
        let deltaX = 1-(image.x/bg.scene.size.width);
        let deltaY = 1-(image.y/bg.scene.size.height);
        bg.scene.addTween(image, 1200, {delay: (300 * deltaX) + (150 * deltaY), x: 1400}, Phaser.Math.Easing.Sine.Out);
    },
    data:[
        {
            key: "BGElmnts_NinjaStr",
            x: 713.82941184147, y: 69.56347438752785,
            angle: 11,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_NinjaStr",
            x: 356.3534432134049, y: 404.5122494432071,
            angle: 11,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_NinjaStr",
            x: 713.98751125553, y: 573.0066815144767,
            angle: 11,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_NinjaStr",
            x: 308.604901538582, y: 179.4543429844098,
            angle: 23,
            scaleX: 0.8499999999999999,
            scaleY: 0.8499999999999999
        },{
            key: "BGElmnts_NinjaStr",
            x: 520.8485821294811, y: 239.61024498886414,
            angle: 17,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_NinjaStr",
            x: 703.7246603766199, y: 328.12026726057906,
            angle: 22,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_NinjaStr",
            x: 308.4601391118245, y: 681.1870824053452,
            angle: 22,
            scaleX: 0.8499999999999999,
            scaleY: 0.8499999999999999
        },{
            key: "BGElmnts_NinjaStr",
            x: 905.4159652350938, y: 231.913140311804,
            angle: 29,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_NinjaStr",
            x: 66.42790588419528, y: 231.7683741648107,
            angle: 28,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_NinjaStr",
            x: 41.62601626016261, y: 418.9198218262806,
            angle: 11,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_NinjaStr",
            x: 522.1247699956936, y: 743.7772828507796,
            angle: 16,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_NinjaStr",
            x: 68.57266831095278, y: 736.3563474387528,
            angle: 27,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_NinjaStr",
            x: 205.6868678959663, y: 524.6792873051226,
            angle: -2,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_NinjaStr",
            x: 881.1797883307887, y: 418.9198218262806,
            angle: 11,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_NinjaStr",
            x: 905.1264403815788, y: 736.2115812917594,
            angle: 29,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_NinjaStr",
            x: 205.97639274948128, y: 21.525612472160358,
            angle: 58,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_NinjaStr",
            x: 477.2314658941132, y: 67.14253897550111,
            angle: 45,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_NinjaStr",
            x: 546.3609468999987, y: 428.3273942093541,
            angle: 38,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_NinjaStr",
            x: 477.50765376032575, y: 571.4409799554566,
            angle: 45,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_NinjaStr",
            x: 1043.899711597437, y: 522.6926503340758,
            angle: 56,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_NinjaStr",
            x: 1043.320661890407, y: 19.064587973273944,
            angle: 56,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_NinjaStr",
            x: 898.4159652350938, y: 74.40534521158129,
            angle: 72,
            scaleX: 0.4499999999999996,
            scaleY: 0.4499999999999996
        },{
            key: "BGElmnts_NinjaStr",
            x: 897.7188270759112, y: 579.8485523385301,
            angle: 72,
            scaleX: 0.4499999999999996,
            scaleY: 0.4499999999999996
        },{
            key: "BGElmnts_NinjaStr",
            x: 197.27925459029873, y: 330.12026726057906,
            angle: 72,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        },{
            key: "BGElmnts_NinjaStr",
            x: 60.44124287149774, y: 576.0066815144767,
            angle: 72,
            scaleX: 0.4499999999999996,
            scaleY: 0.4499999999999996
        },{
            key: "BGElmnts_NinjaStr",
            x: 1037.4654243171644, y: 331.554565701559,
            angle: 72,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        },{
            key: "BGElmnts_NinjaStr",
            x: 58.79550822795548, y: 72.79955456570156,
            angle: 72,
            scaleX: 0.4499999999999996,
            scaleY: 0.4499999999999996
        },{
            key: "BGElmnts_NinjaStr",
            x: 701.8694228033773, y: 832.4877505567929,
            angle: 82,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        }
    ]
}